import { TREATMENT_TYPE } from 'constants/patientList';

/**
 * Braces templatized aligner prescription (external occlusion rules, etc.)
 * applies only when the clinic feature is on and the treatment is BRACES.
 */
export const isBracesTemplatizedAlignerPrescription = (
  isBracesTemplatizedPrescriptionEnabled: boolean | undefined,
  patientTreatmentType: string | undefined
): boolean =>
  !!isBracesTemplatizedPrescriptionEnabled &&
  patientTreatmentType === TREATMENT_TYPE.BRACES;
